module.exports = __webpack_public_path__ + "static/media/asglogo.376f863e.png";